import { Button, ButtonProps } from '@nexelem/components';
import { useCustomTranslation } from '../../../../hooks';
import { isInitialGanttState, useGanttFilterStore } from '../hooks/useGanttFilterStore';
import { PlanView, useProductionPlanQueryParams } from '../hooks';
import { isInitialKanbanState, useKanbanFilterStore } from '../hooks/useKanbanFilterStore';

export const ResetButton = (props: ButtonProps) => {
  const {
    queryParams: { view },
  } = useProductionPlanQueryParams();

  const isKanban = view === PlanView.KANBAN;
  const isGantt = view === PlanView.GANTT;

  if (isKanban) {
    return <KanbanResetButton {...props} />;
  }
  if (isGantt) {
    return <GanttResetButton {...props} />;
  }
};

const KanbanResetButton = (props: ButtonProps) => {
  const { tWrapper } = useCustomTranslation('common');

  const isInitial = useKanbanFilterStore(isInitialKanbanState);
  const reset = useKanbanFilterStore((state) => state.reset);

  if (isInitial) {
    return null;
  }

  return (
    <Button variant="text" onClick={reset} {...props}>
      {tWrapper('reset')}
    </Button>
  );
};

const GanttResetButton = (props: ButtonProps) => {
  const { tWrapper } = useCustomTranslation('common');

  const isInitial = useGanttFilterStore(isInitialGanttState);
  const reset = useGanttFilterStore((state) => state.reset);

  if (isInitial) {
    return null;
  }

  return (
    <Button variant="text" onClick={reset} {...props}>
      {tWrapper('reset')}
    </Button>
  );
};
